module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms19x"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "unLoadBool": true,
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "receivedStore": _vm.receivedHrms19xIndex,
      "maxRowspan": _vm.maxRowspan.index,
      "csvExportDisp": true,
      "sortDisp": false,
      "searchBoxAlias": "hrms19x",
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c7280b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms19x/component.vue
// module id = 3799
// module chunks = 1